var data = {
  medal:[
    {name:'', type:'', dt:'yyyymm'}
  ]
};

var mutations = {
  'SET_MEDAL'(state, medal) {
    
    var idx = -1;
    for(var i=0;i<state.medal.length;i++) {
      var item = state.medal[i];
      if(medal.name == item.name && medal.type == item.type) {
        idx = i;
      }
    }
    if(idx != -1) {
      console.log('store.js medal.js idx', idx);
      state.medal.splice(idx, 1);
    }

    state.medal.push(medal);
  }
};

var getters = {
  medal: state => state.medal
};

export default {
  state: data,
  getters,
  // actions,
  mutations
}
